import React from 'react';
import ReactDOM from 'react-dom/client';

import './tailwind.css'; 
import App from './App';
import { AuthProvider } from './contexts/AuthContext'; // ✅ YENİ: AuthProvider'ı import ediyoruz

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* ✅ YENİ: Tüm uygulamayı AuthProvider ile sarmalıyoruz */}
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

